document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CustomCartDrawer');
  const closeBtn = document.getElementById('CustomCartDrawerClose');
  const PREMIUM_HANDLE = 'premium-delivery-protection';

  /* -------------------------
     DRAWER TOGGLE + OVERLAY
  -------------------------- */
  function toggleCartDrawer(show) {
    const overlay = document.getElementById('CustomCartDrawerOverlay');
    if (show) {
      drawer.classList.add('active');
      overlay.classList.add('active');
      setTimeout(loadCartDrawer, 150);
    } else {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }
  }

  // Overlay & Close button
  document
    .getElementById('CustomCartDrawerOverlay')
    .addEventListener('click', () => toggleCartDrawer(false));
  closeBtn?.addEventListener('click', () => toggleCartDrawer(false));

  /* -------------------------
     BUBBLE UPDATES
  -------------------------- */
  function updateAllCartBubbles(itemCount) {
    document.querySelectorAll('.site-header__cart-bubble').forEach(bubble => {
      if (itemCount > 0)
        bubble.classList.add('site-header__cart-bubble--visible');
      else bubble.classList.remove('site-header__cart-bubble--visible');
    });
  }

  function syncCartBubbles() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateAllCartBubbles(cart.item_count))
      .catch(() => {});
  }

  /* -------------------------
     PREMIUM PROTECTION HELPERS
  -------------------------- */
  async function addPremiumProtection() {
    try {
      const res = await fetch(`/products/${PREMIUM_HANDLE}.js`);
      const product = await res.json();
      const variantId = product.variants[0].id;

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const alreadyInCart = cart.items.some(i => i.handle === PREMIUM_HANDLE);
      if (alreadyInCart) return;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      console.log('✅ Added Premium Protection');
    } catch (err) {
      console.error('Error adding protection:', err);
    }
  }

  async function removePremiumProtection() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const protectionItem = cart.items.find(i => i.handle === PREMIUM_HANDLE);
      if (!protectionItem) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
      });

      console.log('🗑️ Removed Premium Protection');
    } catch (err) {
      console.error('Error removing protection:', err);
    }
  }

  /* -------------------------
     MAIN CART LOGIC
  -------------------------- */
  async function enforceProtectionRule({ fromAdd = false } = {}) {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const hasProtection = cart.items.some(i => i.handle === PREMIUM_HANDLE);
    const visibleItems = cart.items.filter(i => i.handle !== PREMIUM_HANDLE);

    // 🧹 Case 1: Cart empty → remove protection if exists
    if (visibleItems.length === 0 && hasProtection) {
      await removePremiumProtection();
      return;
    }

    // 🧩 Case 2: Only add protection when product added from empty
    if (fromAdd && visibleItems.length === 1 && !hasProtection) {
      await addPremiumProtection();
      return;
    }
  }

  /* -------------------------
     LOAD CART DRAWER
  -------------------------- */
  async function loadCartDrawer() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const drawerItems = document.getElementById('CustomCartDrawerItems');
    const drawerSubtotal = document.getElementById('CustomCartDrawerSubtotal');
    const protectionSection = document.getElementById('PremiumProtectionSection');
    const continueBtn = document.getElementById('CartDrawerContinue');
    if (!drawerItems || !drawerSubtotal) return;

    drawerItems.innerHTML = '';

    const visibleItems = cart.items.filter(i => i.handle !== PREMIUM_HANDLE);

    // 🧠 Product meta description mapping
    const META_DESCRIPTIONS = {
      'the-big-bar-plus': 'Multi-height pull-up bar',
      'the-basebar-flip': 'Dual height pull-up bar',
      'the-basebar-pro': 'Dual height pull-up bar',
      'b-bars': 'Dual height parallel bars',
      'baseblocks-air': 'The all-in-one machine',
      'the-nordic-plus': 'Nordic curl and back extension bench',
      'the-big-bar': 'Full-size pull-up bar',
      'the-big-bar-pro': 'Pull-up and dip station',
      'basebar': 'Dual height pull-up bar',
      'the-basebench': 'Lower body bench',
      'basebench-pro': 'Lower body bench',
      'the-baseblocks-trainer': 'Calisthenics canes',
      'the-mini-bars': 'Modular parallettes',
      'b-bars-pro': 'Dual height parallel bars',
      'the-ring-rack': '(rings and straps included)',
      'the-wall-bars': 'Freestanding wall bars',
      'the-split-bars': 'Pull-up and dip station',
      'the-strongblocks': 'Hybrid parallettes and yoga blocks',
      'the-quick-rings': 'Carabiner-style gymnastics rings',
      'basebands-set': '(three pieces)',
      'the-weight-belt': 'Premium dip and pull-up belt'
    };

    if (visibleItems.length === 0) {
      drawerItems.innerHTML = '<p>Your cart is empty.</p>';
      drawerSubtotal.innerHTML = `
        <div class="subtotal-line">
          <span>Subtotal</span>
          <span>$0.00</span>
        </div>
        <div class="shipping-line">
          <span>Shipping</span>
          <span>Free</span>
        </div>
      `;
      updateAllCartBubbles(0);
      if (protectionSection) protectionSection.style.display = 'none';
      return;
    }

    updateAllCartBubbles(cart.item_count);

    // 🧾 Render items
    visibleItems.forEach(item => {
      const handle = item.handle?.toLowerCase() || '';
      const metaText = META_DESCRIPTIONS[handle] || '';

      drawerItems.innerHTML += `
        <div class="custom-cart-drawer__item" data-key="${item.key}">
          <img src="${item.image}" alt="${item.product_title}" class="custom-cart-drawer__item-image">
          <div class="custom-cart-drawer__item-details">
            <div class="custom-cart-drawer__info">
              <div>
                <p class="custom-cart-drawer__item-title">${item.product_title}</p>
                ${item.variant_title ? `<p class="custom-cart-drawer__item-variant">${item.variant_title}</p>` : ''}
                ${metaText ? `<span class="metaline">${metaText}</span>` : ''}
              </div>
              <div class="custom-cart-drawer__item-price">
                $${(item.line_price / 100).toFixed(2)}
              </div>
            </div>
            <div class="custom-cart-drawer__qty-control">
              <button class="qty-btn minus" data-key="${item.key}">−</button>
              <span class="qty-number">${item.quantity}</span>
              <button class="qty-btn plus" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>`;
    });

    // ✅ Subtotal + Shipping (clean block)
    drawerSubtotal.innerHTML = `
      <div class="subtotal-line">
        <span>Subtotal</span>
        <span>$${(cart.total_price / 100).toFixed(2)}</span>
      </div>
      <div class="shipping-line">
        <span>Shipping</span>
        <span>Free</span>
      </div>
    `;

    attachQtyListeners();
    renderPremiumProtection(cart);
    continueBtn?.addEventListener('click', () => toggleCartDrawer(false));
  }

  /* -------------------------
     QUANTITY UPDATE BUTTONS
  -------------------------- */
  function attachQtyListeners() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async e => {
        const key = e.currentTarget.dataset.key;
        const isPlus = e.currentTarget.classList.contains('plus');

        const res = await fetch('/cart.js');
        const cart = await res.json();
        const item = cart.items.find(i => i.key === key);
        if (!item) return;

        const newQty = isPlus ? item.quantity + 1 : item.quantity - 1;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });

        await enforceProtectionRule(); // Keep premium protection logic
        loadCartDrawer();
        syncCartBubbles();
      });
    });
  }

  /* -------------------------
     PREMIUM PROTECTION UI
  -------------------------- */
  function renderPremiumProtection(cart) {
    const container = document.getElementById('PremiumProtectionSection');
    if (!container) return;

    const hasOtherItems = cart.items.some(i => i.handle !== PREMIUM_HANDLE);
    const hasProtection = cart.items.some(i => i.handle === PREMIUM_HANDLE);

    container.style.display = hasOtherItems ? 'block' : 'none';
    container.innerHTML = `
      <div class="premium-protection">
        <div class="premium-protection__header">
          <span class="premium-protection__title">Premium Package Protection</span>
          <label class="premium-protection__switch">
            <input type="checkbox" id="premiumProtectionToggle" ${hasProtection ? 'checked' : ''}>
            <span class="slider"></span>
          </label>
        </div>
        <p class="premium-protection__text">
          For $7.25, we protect your delivery in the event it is damaged, stolen, or lost during transit.
        </p>
      </div>`;

    const toggle = document.getElementById('premiumProtectionToggle');
    toggle?.addEventListener('change', async e => {
      if (e.target.checked) {
        await addPremiumProtection();
      } else {
        await removePremiumProtection();
      }
      loadCartDrawer();
    });
  }

  /* -------------------------
     ADD TO CART (Intercept)
  -------------------------- */
  document.querySelectorAll('form.product-form').forEach(form => {
    const addBtn = form.querySelector('.product__add-to-cart-button');
    addBtn?.addEventListener(
      'click',
      async e => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const formData = new FormData(form);
        await fetch('/cart/add.js', { method: 'POST', body: formData });
        await enforceProtectionRule({ fromAdd: true }); // ✅ add only when first item
        toggleCartDrawer(true);
        syncCartBubbles();
      },
      true
    );
  });

  /* -------------------------
     HEADER CART CLICK
  -------------------------- */
  document.addEventListener(
    'click',
    e => {
      const target = e.target.closest('.site-header__cart.ajax-cart__toggle');
      if (!target) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleCartDrawer(true);
    },
    true
  );

  syncCartBubbles();
});
